import React,{useState} from 'react';

///Styles
import { Container,ContainerSales} from './styles';

///Components
import { FinishedSales } from './finishedSales';
import { CanceledSales } from './canceledSales';

export function Sales(){

    const [componentSelected,setComponentSelected] = useState('0');

    return(
        <Container>
            <ContainerSales>
                <div className='filter-container'>
                    <div className='radio-container'>
                        <input
                            type={'radio'}
                            value={'0'}
                            onChange={(event) => setComponentSelected(event.target.value)}
                            checked={'0' === componentSelected}
                            className='radio'
                            id='radio1'
                        />
                        <label htmlFor='radio1'>
                            Canceladas 
                        </label>
                    </div>

                    <div className='radio-container'>
                        <input
                            type={'radio'}
                            value={'1'}
                            onChange={(event) => setComponentSelected(event.target.value)}
                            checked={'1' === componentSelected}
                            className='radio'
                            id='radio2'
                        />
                    
                        <label htmlFor='radio2'>
                            Finalizadas
                        </label>
                    </div>
                </div>
                
                {
                        componentSelected === '0' ?
                        <CanceledSales/>
                        :
                        <FinishedSales/>
                }
            </ContainerSales>
        </Container>
    )
}